import React, { useState } from "react";
import { Col, Form, Input, Radio, Row, Select, Space } from "antd";
import Templates from "./Templates";
import { eligibleCharge } from "../../../../../utils/NewPropertyHelper";
import Terms from "./Terms";

function LeaseSettings({ initialValues, terms, setTerms, dLT, sDLT, dRT, sDRT, dMRT, sDMRT}) {
  const [value, setValue] = useState(initialValues.leaseGenerationMethod);
  const [changeRentBy, setChangeRentBy] = useState("dollar");
  const onChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <>
      <Form.Item
        label="Select a Default Lease Generation Method"
        name="leaseGenerationMethod"
      >
        <Radio.Group onChange={onChange} value={value}>
          <Space direction="vertical">
            <Radio value="SayEagle Lease Templates">
              SayEagle Lease Templates
            </Radio>
            <Radio value="PDF Form Templates">PDF Form Templates</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <br />
      <h4>Default Lease Templates</h4>
      <br />
      {value === "SayEagle Lease Templates" ? (
        <>
          <Form.Item label="Lease Template" name="leaseTemplate">
            <Select
              showSearch
              options={[{ value: "New Move in Lease Template" }, { value: "Renewal Lease Template" }]}
            />
          </Form.Item>
          <Form.Item label="Addenda Template(s)" name="addendaTemplates">
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[{ value: "Addenda template 1" }, { value: "Addenda template 2" }]}
            />
          </Form.Item>
          <Form.Item label="Lease Attachment(s)" name="leaseAttachments">
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[{ value: "Lease Attachment 1" }, { value: "Lease Attachment 2" }]}
            />
          </Form.Item>
        </>
      ) : (
        <>
          <Form.Item label="Lease Template(s)">
            <Templates templates={dLT} setTemplates={sDLT}/>
          </Form.Item>
        </>
      )}
      <br />
      <h4>Default Renewal Templates</h4> <br />
      {value === "SayEagle Lease Templates" ? (
        <>
          <Form.Item label="Lease Template" name="SayeagleRenewalTemplate">
            <Select
              showSearch
              options={[{ value: "New Move in Lease Template" }, { value: "Renewal Lease Template" }]}
            />
          </Form.Item>
          <Form.Item label="Addenda Template(s)" name="renewalAddendaTemplates">
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[{ value: "Addenda template 1" }, { value: "Addenda template 2" }]}
            />
          </Form.Item>
          <Form.Item label="Lease Attachment(s)" name="renewalAttachments">
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[{ value: "Lease Attachment 1" }, { value: "Lease Attachment 2" }]}
            />
          </Form.Item>
        </>
      ) : (
        <>
          <Form.Item label="Lease Template(s)">
            <Templates templates={dRT} setTemplates={sDRT} />
          </Form.Item>
        </>
      )}
      <br />
      <h4>Default Renewal Month to Month Templates</h4> <br />
      {value === "SayEagle Lease Templates" ? (
        <>
          <Form.Item label="Lease Template" name="mTMRenewalTemplate">
            <Select
              showSearch
              options={[{ value: "New Move in Lease Template" }, { value: "Renewal Lease Template" }]}
            />
          </Form.Item>
          <Form.Item
            label="Addenda Template(s)"
            name="mTMRenewaladdendaTemplates"
          >
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[{ value: "Addenda template 1" }, { value: "Addenda template 2" }]}
            />
          </Form.Item>
          <Form.Item label="Lease Attachment(s)" name="mTmRenewalAttachments">
            <Select
              mode="tags"
              tokenSeparators={[]}
              options={[{ value: "Lease Attachment 1" }, { value: "Lease Attachment 2" }]}
            />
          </Form.Item>
        </>
      ) : (
        <>
          <Form.Item label="Lease Template(s)">
            <Templates templates={dMRT} setTemplates={sDMRT}/>
          </Form.Item>
        </>
      )}
      <br />
      <h4>Default Renewal Settings</h4> <br />
      <br />
      <Form.Item
        label="Choose Template(s)"
        wrapperCol={{ span: 8 }}
        name="template"
      >
        <Select
          showSearch
          options={eligibleCharge}
          initalvalues={eligibleCharge[0]}
          placeholder="Choose Templates ..."
        />
      </Form.Item>
      <Form.Item label="Charge rent by" name="changeRentBy">
        <Radio.Group
          onChange={(e) => {
            setChangeRentBy(e.target.value);
          }}
          value={changeRentBy}
        >
          <Space direction="vertical" style={{ marginTop: 6 }}>
            <Radio value="dollar">Dollar Amount</Radio>
            <Radio value="percentage">Percentage</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item label="Renewal Options">
        <Row gutter={[8,0]}>
          <Col className="tableHead" span={10}>
            <p>Term</p>
          </Col>
          <Col className="tableHead" span={7}>
            <p>Change by {changeRentBy === "dollar" ? <>$</> : <>%</>}</p>
          </Col>
          <Col className="tableHead" span={6}>
            <p>Additional Fee</p>
          </Col>
          <Col span={1}></Col>
        </Row>
        <Terms changeRentBy={changeRentBy} terms={terms} setTerms={setTerms} />
      </Form.Item>
    </>
  );
}

export default LeaseSettings;
